var _style, _circle, _defs, _clipPath, _g, _defs2, _clipPath2, _g2, _defs3, _clipPath3, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDownloadConcrete = function SvgDownloadConcrete(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 80 80",
    viewBox: "0 0 80 80",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{clip-path:url(#SVGID_00000130648994518208878010000016025008013316741034_);}\n\t.st2{fill:#EAEAEA;}\n\t.st3{clip-path:url(#SVGID_00000160160336459789156440000013773701797511601834_);}\n\t.st4{fill:#FFFFFF;}\n\t.st5{clip-path:url(#SVGID_00000168106964784191687090000011090046626013308086_);}\n\t.st6{fill:#EA4403;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 40,
    cy: 40,
    r: 40
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 80,
    height: 80
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80,40c0,22.09-17.91,40-40.001,40C17.91,80,0,62.09,0,40C0,17.907,17.91,0,39.999,0     C62.09,0,80,17.907,80,40"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "b",
    width: 80,
    height: 80
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m24.346 28.556c-1.476 0-2.671 1.197-2.671 2.671v26.524c0 1.353 1.013 2.449 2.265 2.449h31.74c1.251 0 2.265-1.096 2.265-2.449v-26.524c0-1.474-1.196-2.671-2.671-2.671h-30.928z"
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "d",
    width: 80,
    height: 80
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m43.205 42.046v-28.149c0-0.64-0.518-1.16-1.158-1.16h-4.293c-0.64 0-1.158 0.519-1.158 1.16v28.18l-7.36 0.033c-1.03 4e-3 -1.542 1.251-0.813 1.978l10.121 10.121c0.44 0.441 1.15 0.453 1.607 0.029l11.015-10.215c0.775-0.718 0.263-2.014-0.793-2.008l-7.168 0.031z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadConcrete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/download-concrete.067ee0f8b1978b289da903f0ed41c1db.svg";